import React from 'react';
import cls from 'classnames';
import './From.scss';

/**
 * @param {object} props
 * @param {boolean} checked
 * @param {string} name
 */

function CusRadio({
  checked,
  title,
  name,
  onChange = () => { },
  ...props
}) {
  return (
    <div className="d-flex align-items-center pb-2">
      <label className={cls('CusRadio d-flex flex-shrink-0')}>
        <input
          type="radio"
          checked={checked}
          style={{ display: 'none' }}
          onChange={onChange}
        />
        {checked && (
          <svg height="18px" width="18px" viewBox="0 0 18 18">
            <circle cx="9" cy="9" r="6" />
          </svg>
        )}
      </label>
      <span className="ml-3" onClick={onChange}>{title}</span>
    </div>
  );
}

export { CusRadio };
